import { API_BASE_URL } from "@/config";
import LivenessCheck from "@/components/Verification/liveness_check/LivenessCheck.vue";
import ClientLogo from "@/components/ClientLogo/ClientLogo.vue";
import { MAIN_CONTROLLER } from "@/utils/main_controller.js";
import BreadCrumb from "@/components/BreadCrumb/BreadCrumb.vue";
import { validateToken } from "@/utils/auth";
import Swal from "sweetalert2";

export default {
  name: "IndividualLivenessVerification",
  mixins: [MAIN_CONTROLLER],
  data: () => ({
    photo_src: "",
    get_consent: false,
    consent_provided: false,
    is_id_valid: false,
    showCamera: false,
    showInstructions: false,
    show_error: false,
    error_message: "",
  }),
  created() {
    this.consent_provided =
      localStorage.getItem("facial_biometrics_consent") === "true";
  },
  computed: {
    workflow_id() {
      return this.$store.getters.get_workflow_id;
    },
  },
  components: {
    LivenessCheck,
    ClientLogo,
    BreadCrumb
  },
  methods: {
    clear_error_message() {
      this.error_message = "";
      this.show_error = false;
    },
    set_photo_src(photo_src) {
      this.photo_src = photo_src;
      this.$refs.liveness_check.close_modal();
      this.individual_liveness_verification();
    },
    individual_liveness_verification() {
      const TOKEN = localStorage.getItem("token");
      const LIVENESS_VERIFICATION_ONLY_URL = `${API_BASE_URL}/verify_api/personnel_verification/liveness_verification_only/`;

      $.ajax({
        url: LIVENESS_VERIFICATION_ONLY_URL,
        method: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        data: JSON.stringify({
          comparisonImage: this.photo_src,
          workflow_id: this.workflow_id,
        }),
        beforeSend: () => {
          Swal.fire({
            text: "Finalizing liveness verification...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
        },
        success: (response) => {
          if (response.status === "success") {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Liveness verification successful.",
            }).then(() => {
              this.fetch_current_service();
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Failed",
              text: response.message || "Liveness verification failed.",
            });
          }
        },
        error: () => {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "An error occurred during liveness verification. Please try again.",
          });
        },
      });
    },
    async startFaceRecognition() {
      this.showCamera = false;
      this.showInstructions = false;

      this.$refs.liveness_check.unlockAudio();

      await new Promise((resolve) => setTimeout(resolve, 100));

      this.showCamera = true;

      await this.$nextTick();

      try {
        await this.$refs.liveness_check.startFaceRecognition();
      } catch (error) {
        console.error("Error starting face recognition:", error);
        Swal.fire({
          icon: "error",
          text: "Unable to start facial recognition. Please try again.",
        });
        this.showCamera = false;
        this.showInstructions = true;
      }
    },
    start_liveness_check() {
      this.$refs.liveness_check.set_id_number(this.client_id);
    },
    get_terms_and_conditions() {
      const TOKEN = localStorage.getItem("token");
      const GET_TERMS_AND_CONDITIONS_API = `${API_BASE_URL}/verify_api/system_management_api/get_terms_and_conditions_api/`;
      $.ajax({
        url: GET_TERMS_AND_CONDITIONS_API,
        method: "GET",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        beforeSend: () => {
          Swal.fire({
            text: "Loading ...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
        },
        success: (response) => {
          Swal.close();

          this.get_consent = response.get_consent;
          this.consent_provided = response.get_consent;

          if (response.get_consent) {
            localStorage.setItem("facial_biometrics_consent", "true");
            localStorage.setItem("user_state", "consent_given");
          }
        },
        error: () => {
          Swal.close();
        },
      });
    },
    accept() {
      const TOKEN = localStorage.getItem("token");
      const CONCENT_URL = `${API_BASE_URL}/verify_api/system_management_api/terms_and_conditions_api/`;

      const FORM_DATA = {
        consent_provided: true,
      };

      $.ajax({
        url: CONCENT_URL,
        method: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        data: JSON.stringify(FORM_DATA),
        beforeSend: () => {
          Swal.fire({
            text: "Loading ...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
        },
        success: () => {
          Swal.close();
          this.consent_provided = true;
          localStorage.setItem("facial_biometrics_consent", "true");
          localStorage.setItem("user_state", "consent_given");
          const modal = document.getElementById("terms_and_conditions_modal");
          if (modal) {
            modal.style.display = "none";
          }
          this.$emit("consent-updated", true);
        },
        error: () => {
          Swal.close();
          Swal.fire({
            icon: "error",
            text: "Error saving consent. Please try again.",
          });
        },
      });
    },
    decline() {
      Swal.fire({
        title: "Are you sure you want to decline?",
        text: "You cannot proceed with the application if consent is not provided.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          localStorage.removeItem("token");
          localStorage.removeItem("user_state");
          this.$router.push("/");
        }
      });
    },
    show_popup() {
      const modal = document.getElementById("terms_and_conditions_modal");
      if (modal) {
        modal.style.display = "block";
      }
    },
    hide_popup() {
      const modal = document.getElementById("terms_and_conditions_modal");
      if (modal) {
        modal.style.display = "none";
      }
    },
  },
  mounted() {
    if (!validateToken(this.$router)) {
      return;
    }
    this.get_terms_and_conditions();

    const user_state = localStorage.getItem("user_state");
    if (user_state === "consent_given") {
      this.consent_provided = true;
    }
  },
  watch: {
    get_consent(consent) {
      if (consent) {
        this.hide_popup();
      } else {
        this.show_popup();
      }
    },
    showCamera(newValue) {
      this.$emit("camera-state-changed", newValue);
    },
  },
};
